// extracted by mini-css-extract-plugin
export default {"dealerName":"GameLiveDealerName__dealerName--Ob6"};